<template>
  <div class="play-list-pane" :style="{'padding-top': webWithoutNavigation ? '42px' : 0}">
    <div class="play-wapper" v-for="(item, i) in playList" :key="i" @click="handlePlayVideo(item, onService, roomId)">
      <div class="item-title">{{getFormateDate(item.createdAt)}} {{item.title | formatTitile(20)}}</div>
      <div class="time-pane">
        <img :src="require('@/assets/time.png')" class="time-icon"/>
        <span style="margin: 0 .05rem">时长</span>
        <span>{{item.duration | durationFormat}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import formatTitile from '@/filters/text-overflow'
import {durationFormat} from '@spero/spero-utils/src/helpers/date'
import csMixins from './cs-mixins'
import {debounce} from '../helpers/utils'
export default {
  data () {
    return {
      playList: [],
      onService: false,
      roomId: 0
    }
  },
  props: ['id'],
  filters: {formatTitile, durationFormat},
  mixins: [csMixins],
  methods: {
    getData () {
      console.log('user', this.USERINFO.isTourist)
      if (this.USERINFO.isTourist) {
        this.toLogin()
        return
      }
      debounce(async () => {
        try {
          const {id} = this
          const {data: {code, message, data}} = await this.$rootApi.api(['getCSRePlayList'], {
            data: {serviceId: id}
          })
          if (code === 0) {
            const {tapeList, serviceName, onService, roomId} = data
            this.SET_PAGE_TITLE(serviceName + '-往期')
            Object.assign(this, {
              onService,
              roomId
            })
            this.$sa.pageview({
              title: '回放列表',
              roomid: id
            })
            if (!onService) {
              this.permissionModel()
              return
            }
            this.playList = tapeList || []
          } else {
            throw message
          }
        } catch (err) {
          // err && this.$toast(err.message || err)
        }
      }, 500)
    }
  },
  watch: {
    SCROLL_TO_BOTTOM (v) {
      if (v > 50) {
        console.log(v)
        this.getData()
      }
    },
    loginCount: {
      immediate: true,
      handler: function (v) {
        console.log('loginCount3', v)
        if (v > 0) {
          this.getData()
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.play-wapper
  -webkit-user-select none
  border-bottom: 1px solid #F6F6F6
  padding: .15rem .27rem .15rem .2rem
  .item-title
    font-size: .16rem
    color: #333333
    &:hover
      color: #FFC200
      font-weight: 700
  .time-pane
    font-size: .12rem
    color: #999
    display: flex
    flex-direction: row
    align-items: center
    padding-top: .01rem
    .time-icon
      width: .1rem
      height: .1rem
.no-more
  font-size: .13rem
  color: #999
  text-align: center
  padding: .11rem 0
</style>
